import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectapplicationsQueryItems } from '../../../../../redux/applications/selector';
import { applications } from '../../../../../redux/applications/action';
import { selectTenantsListItems } from '../../../../../redux/tenants/selector';
import { tenants } from '../../../../../redux/tenants/action';
import moment from 'moment';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile'
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selecttenantDomainFunctionsListItems } from '../../../../../redux/TenantDomainFunctions/selector';
import { selecttenantDomainsListItems } from '../../../../../redux/tenant-domains/selector';
import { tenantDomains } from '../../../../../redux/tenant-domains/action';
import { tenantDomainFunctions } from '../../../../../redux/TenantDomainFunctions/action';
import { selectChannelListItems } from '../../../../../redux/channels/selector';
import { channels } from '../../../../../redux/channels/action';
import ApplicationRegistrationComponent from '../components/application.component';
import { deepCopy } from '../../../../../common/services/common.service';
import { selectnetworksListItems } from '../../../../../redux/networks/selector';
import { networks } from '../../../../../redux/networks/action';
import { selectDomainsListItems } from '../../../../../redux/domains/selector';
import { domains } from '../../../../../redux/domains/action';
let currentChange: any = {}



const Application= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const queryItems = useSelector(selectapplicationsQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const tenantItems = useSelector(selectTenantsListItems)
  const DomainFunctionItems = useSelector(selecttenantDomainFunctionsListItems)
  const DomainItems = useSelector(selecttenantDomainsListItems)
  const domainItems = useSelector(selectDomainsListItems)
  const NetworkItems = useSelector(selectnetworksListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const channelItems = useSelector(selectChannelListItems)
const [
  selectedApplicationRegistreation,
  setSelectedApplicationRegistreation
] = useState<any>({
  LimitedToTenantMappings: {
    LimitedToTenantIds: []
  },
  ChannelMappings: {
    ChannelNames: []
  },
  AccountTypeMappings: {
    AccountTypes: []
  },
  NetworkMappings: {
    Networks: []
  },
  Configurations: {},
  ApplicationRegConfigurations: {},
  network_participant: [],
  MediaMappings: {
    MediaFiles: [],
    Templates: []
  }
})
const [
  mediaImageIndex,
  setMediaImageIndex
] = useState<any>([])
const [
  sellerOnRecords,
  setSellerOnRecords
] = useState([])
const [
  applicationRegistreation,
  setApplicationRegistreation
] = useState<any>([])
const [
  networkParticipants,
  setNetworkParticipants
] = useState([])
const [
  mediaFiles,
  setMediaFiles
] = useState<any>([])
const [
  openFile,
  setOpenFile
] = useState<any>([]);
const [
  functionItems,
  setFunctionItems
] = useState<any>([])
const [
  menuMapping,
  setMenuMapping
] = useState<any>([])
const [hasAddedMenuRow, setHasAddedMenuRow] = useState(false);
 
  const fetchApplicationById= ()=>{
    dispatch(applications.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/applications/query`,entity:'applications',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  useEffect(
    () => {
      dispatch(tenantDomains.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenant-domains/list`,
        entity: 'tenantDomains',
        jsonData: {}
    })).then(()=>{
      dispatch(networks.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`,
        entity: 'networks',
        jsonData: {}
    })).then(()=>{
      dispatch(domains.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,
        entity: 'domains',
        jsonData: {}
    }))}).then(()=>{
    //   dispatch(tenantDomainFunctions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`,entity:'tenantDomainFunctions',jsonData:{
    //   }}))
    // })}).then(()=>{
      dispatch(channels.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/channels/list`,entity:'channels',jsonData:{
      }}))
    })}).then(()=>{
      dispatch(tenants.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenants/all-list`,entity:'tenants',jsonData:{
      }}))
    })

      if (parmas?.id > 0) {
        fetchApplicationById()
        setIsLoading(false)
      }
      else{
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        // const localSelectedFunction = addNewFunctionRow({ selectedFunctionArg: functionItems });
        // setFunctionItems(localSelectedFunction)
        const localSelectedMenuMapping = addNewMenuMappingRow({ selectedMenuMappingArg: menuMapping });
        setMenuMapping(localSelectedMenuMapping)
        const localSelectedNetworks = addNewRow({ selectedNetworksArg: networkParticipants });
        setNetworkParticipants(localSelectedNetworks)
        const localSelectedSeller = addNewSellerRow({ selectedSellersArg: sellerOnRecords, networkParticipant: networkParticipants, idx: 0, idx1: 0 });
        setSellerOnRecords(localSelectedSeller)
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedApplicationRegistreation(queryItems?.result?.items)
        applicationRegistreation.LimitedToTenantIds = selectedApplicationRegistreation?.LimitedToTenantMappings?.LimitedToTenantIds
        applicationRegistreation.ChannelNames = selectedApplicationRegistreation?.ChannelMappings?.ChannelNames
        applicationRegistreation.AccountTypes = selectedApplicationRegistreation?.AccountTypeMappings?.AccountTypes
        applicationRegistreation.Networks = selectedApplicationRegistreation?.NetworkMappings?.Networks
        const applicationData = queryItems?.result?.items?.ApplicationRegConfigurations
        applicationRegistreation.ops_no = applicationData?.context?.operation?.ops_no
        applicationRegistreation.legal_entity_name = applicationData?.message?.entity?.gst?.legal_entity_name
        applicationRegistreation.business_address = applicationData?.message?.entity?.gst?.business_address
        applicationRegistreation.gst_city_code = applicationData?.message?.entity?.gst?.city_code
        applicationRegistreation.gst_no = applicationData?.message?.entity?.gst?.gst_no
        applicationRegistreation.name_as_per_pan = applicationData?.message?.entity?.pan?.name_as_per_pan
        applicationRegistreation.pan_no = applicationData?.message?.entity?.pan?.pan_no
        applicationRegistreation.date_of_incorporation = applicationData?.message?.entity?.pan?.date_of_incorporation
        applicationRegistreation.name_of_authorised_signatory = applicationData?.message?.entity?.name_of_authorised_signatory
        applicationRegistreation.address_of_authorisedSignatory = applicationData?.message?.entity?.address_of_authorisedSignatory
        applicationRegistreation.email_id = applicationData?.message?.entity?.email_id
        applicationRegistreation.mobile_no = applicationData?.message?.entity?.mobile_no
        applicationRegistreation.country = applicationData?.message?.entity?.country
        applicationRegistreation.subscriber_id = applicationData?.message?.entity?.subscriber_id
        applicationRegistreation.unique_key_id = applicationData?.message?.entity?.unique_key_id
        applicationRegistreation.callback_url = applicationData?.message?.entity?.callback_url
        applicationRegistreation.signing_public_key = applicationData?.message?.entity?.key_pair?.signing_public_key
        applicationRegistreation.encryption_public_key = applicationData?.message?.entity?.key_pair?.encryption_public_key
        applicationRegistreation.valid_from = applicationData?.message?.entity?.key_pair?.valid_from
        applicationRegistreation.valid_until = applicationData?.message?.entity?.key_pair?.valid_until
         const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
         setMediaFiles(localSelectedMedia)
        // const localSelectedfunction = addNewFunctionRow({ selectedFunctionArg:queryItems?.result?.items?.FeaturesAndFunctionMappings });
        // setFunctionItems(localSelectedfunction)
        setMenuMapping(addNewMenuMappingRow({ selectedMenuMappingArg: [{ MenuIds: queryItems?.result?.items?.InterfaceMenuMapping?.flatMap((mapping: any) => mapping.MenuIds) || [] }] }));
        const networkItemsData: any = queryItems?.result?.items?.ApplicationRegConfigurations?.message?.network_participant.map((item: any) => {
          const itemdData = {
            subscriber_url: item?.subscriber_url,
            domain: item?.domain,
            type: item?.type,
            msn: item?.msn,
            network_city_code: item?.city_code,
            seller_on_record: item?.seller_on_record?.map((sellerData: any) => ({
              seller_unique_key_id: sellerData?.unique_key_id,
              seller_signing_public_key: sellerData.key_pair?.signing_public_key,
              seller_encryption_public_key: sellerData.key_pair?.encryption_public_key,
              seller_valid_from: sellerData?.key_pair?.valid_from,
              seller_valid_until: sellerData?.key_pair?.valid_until,
              seller_city_code: sellerData?.city_code
            }))
            
          }
          return itemdData
        }) || []
        const localSelectedNetwork = addNewRow({ selectedNetworksArg: networkItemsData || [] });
        setNetworkParticipants(localSelectedNetwork)
        const updatedSeller = networkItemsData.map((networkParticipant: any, index: any) => {
          const localSelectedseller = addNewSellerRow({
            selectedSellersArg: networkParticipant?.seller_on_record,
            networkParticipant: localSelectedNetwork ,
            idx: networkParticipant?.seller_on_record.length,
            idx1: index
          });
          return localSelectedseller;
        });
        setSellerOnRecords(updatedSeller)
      }
    },
    [isQuery]
  )
 
  const handleFormItemNetworkChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(networkParticipants);
    let item = items[idx];
    item = { ...item, [field]: value }
    items[idx] = item;
    currentChange = { value, field, idx }
    setNetworkParticipants(items);
  }

  const addNewRow = ({ selectedNetworksArg}: any) => {
    const localSelectedNetworks = deepCopy(selectedNetworksArg)
    const newsData = {
      Id: 0,
      subscriber_url: '',
      domain: '',
      type: '',
      msn: false,
      network_city_code: [],
      seller_on_record: [
        {
          seller_unique_key_id: '',
          seller_signing_public_key: '',
          seller_encryption_public_key: '',
          seller_valid_from: '',
          seller_valid_until: '',
          seller_city_code: []
        }
      ]
    }
    if (localSelectedNetworks.length === 0 ||
      localSelectedNetworks[localSelectedNetworks?.length - 1]?.subscriber_url !== ''
    ) {
      localSelectedNetworks?.push(newsData);
    }

    return localSelectedNetworks
  }

  const addNewSellerRow = ({ selectedSellersArg, networkParticipant, idx1 }: any) => {
    const localSelectedseller = deepCopy(selectedSellersArg)
    const newSelectedSeller = {
      seller_unique_key_id: '',
      seller_signing_public_key: '',
      seller_encryption_public_key: '',
      seller_valid_from: '',
      seller_valid_until: '',
      seller_city_code: []
    }

    if (localSelectedseller.length === 0 ||
      networkParticipant[idx1]?.seller_on_record[networkParticipant[idx1]?.seller_on_record?.length - 1]?.seller_unique_key_id !== ''
    ) {
      networkParticipant[idx1]?.seller_on_record?.push(newSelectedSeller)
    }

    return localSelectedseller
  }
  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 179,
      OwnerId: parmas?.id,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 0]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setMediaCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const handleFormMediaChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }
 
  const deleteItems = async (Item: any, index: any) => {
    functionItems?.splice(
      index,
      1
    )
  }

  const deleteMenuMappingItems = async (Item: any, index: any) => {
    menuMapping?.splice(
      index,
      1
    )
  }
  const deleteSelectedNetwork = async (Item: any, index: any) => {
    networkParticipants?.splice(
      index,
      1
    )
  }

  const deleteselectedSellerOnRecord = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      sellerOnRecords?.splice(
        index,
        1
      )
    }
  }
  const handleFormFunctionItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(functionItems);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setFunctionItems(items);
  }

  const handleFormMenuMappingItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(menuMapping);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMenuMapping(items);
  }


  const handleFormSellerItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.seller_on_record);
    items[idx] = { ...items[idx], [field]: value };
    currentChange = { value, field, idx, idx1 }
    setSellerOnRecords(items);
    const updatedCardValue: any = [...networkParticipants];
    updatedCardValue[idx1] = { ...cardValue, seller_on_record: items };
    setNetworkParticipants(updatedCardValue);
  }

  const addNewMenuMappingRow = ({ selectedMenuMappingArg }: any) => {
    const localSelectedMenuMapping = Array.isArray(selectedMenuMappingArg) ? deepCopy(selectedMenuMappingArg) : [];
  
    const newsLogistics = {
      MenuIds: ''
    }
    if (localSelectedMenuMapping.length === 0 ||
      localSelectedMenuMapping[localSelectedMenuMapping?.length - 1]?.MenuIds !== 0
    ) {
      localSelectedMenuMapping?.push(newsLogistics)
    }

    return localSelectedMenuMapping
  }
  const setCombinationMenuMappingInfo = async () => {
    let localSelectedMenuMapping = deepCopy(menuMapping)
    localSelectedMenuMapping.splice(
      currentChange.idx,
      1,
      { ...localSelectedMenuMapping[currentChange.idx] }
    );
    localSelectedMenuMapping = addNewMenuMappingRow({ selectedMenuMappingArg: localSelectedMenuMapping });
    currentChange.field = 'MenuIdsDONE'
    setMenuMapping(localSelectedMenuMapping)
  }

  const addNewFunctionRow = ({ selectedFunctionArg }: any) => {
    const localSelectedfunction = deepCopy(selectedFunctionArg)
    const newsLogistics = {
      Id: 0,
      DomainId: 0,
      SubDomainId: 0,
      FunctionIds: ''

    }
    if (localSelectedfunction.length === 0 ||
      localSelectedfunction[localSelectedfunction?.length - 1]?.DomainId !== 0
    ) {
      localSelectedfunction?.push(newsLogistics)
    }

    return localSelectedfunction
  }
  const setCombinationFunctionInfo = async () => {
    let localSelectedFunction = deepCopy(functionItems)
    localSelectedFunction.splice(
      currentChange.idx,
      1,
      { ...localSelectedFunction[currentChange.idx] }
    );
    localSelectedFunction = addNewFunctionRow({ selectedFunctionArg: localSelectedFunction });
    currentChange.field = 'DomainIdsDONE'
    setFunctionItems(localSelectedFunction)
  }
  const handleFormChange: any = ({ field, value }: any) => {
    currentChange = { value, field, idx: 0 }
    setApplicationRegistreation({ ...applicationRegistreation, [field]: value })
    setSelectedApplicationRegistreation({ ...selectedApplicationRegistreation, [field]: value })
  }

const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    // functionItems.splice(
    //   functionItems.length - 1,
    //   1
    // )
    // menuMapping.splice(
    //   menuMapping.length - 1,
    //   1
    // )
    // sellerOnRecords.slice(
    //   sellerOnRecords.length - 1,
    //   1
    // )
    // networkParticipants.splice(
    //   networkParticipants.length - 1,
    //   1
    // )

    // Extract `Id` values from `applicationRegistreation?.Networks`
const networkIds = applicationRegistreation?.Networks || [];

// Map network `Id` values to corresponding `Name` values
const accountTypes = networkIds
  .map((networkId: number) => {
    const matchingNetwork = NetworkItems?.result?.items.find((item: any) => item.Id === networkId);
    return matchingNetwork?.Name;
  })
  .filter((name: any): name is string => !!name); // Remove undefined values
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    console.log(NetworkItems,'NetworkItems')
    const networkData: any = networkParticipants.map((item: any) => {
      item.seller_on_record.splice(
        item.seller_on_record.length - 1,
        1
      )
      const itemData = {
        subscriber_url: item?.subscriber_url,
        domain: item?.domain,
        type: item?.type,
        msn: item?.msn,
        city_code: item?.network_city_code,
        seller_on_record: item?.seller_on_record?.map((sellerItem: any) => ({
          unique_key_id: sellerItem?.seller_unique_key_id,
          key_pair: {
            signing_public_key: sellerItem?.seller_signing_public_key,
            encryption_public_key: sellerItem?.seller_encryption_public_key,
            valid_from: sellerItem?.seller_valid_from,
            valid_until: sellerItem?.seller_valid_until
          },
          city_code: sellerItem?.seller_city_code
        }))

      }
      return itemData
    })
    const Data: any = {
      Id: selectedApplicationRegistreation?.Id || 0,
      Name: selectedApplicationRegistreation?.Name,
      Code: selectedApplicationRegistreation?.Code,
      DomainId: selectedApplicationRegistreation?.DomainId,
      SecretKey: selectedApplicationRegistreation?.SecretKey,
      ShortDescription: selectedApplicationRegistreation?.ShortDescription,
      LongDescription: selectedApplicationRegistreation?.LongDescription,
      LimitedToTenants: selectedApplicationRegistreation?.LimitedToTenants,
      // FeaturesAndFunctionMappings: functionItems,
      Configurations: {
        IsPublished: selectedApplicationRegistreation?.IsPublished
      },
      MediaMappings:{
        MediaFiles:mediaFiles,
        Templates: []
      },
      ApplicationRegConfigurations: {
        context: {
          operation: {
            ops_no: applicationRegistreation?.ops_no
          }
        },
        message: {
          entity: {
            gst: {
              legal_entity_name: applicationRegistreation?.legal_entity_name,
              business_address: applicationRegistreation?.business_address,
              city_code: applicationRegistreation.gst_city_code,
              gst_no: applicationRegistreation?.gst_no
            },
            pan: {
              name_as_per_pan: applicationRegistreation?.name_as_per_pan,
              pan_no: applicationRegistreation?.pan_no,
              date_of_incorporation: applicationRegistreation?.date_of_incorporation
            },
            name_of_authorised_signatory: applicationRegistreation?.name_of_authorised_signatory,
            address_of_authorisedSignatory: applicationRegistreation?.address_of_authorisedSignatory,
            email_id: applicationRegistreation?.email_id,
            mobile_no: applicationRegistreation?.mobile_no,
            country: applicationRegistreation?.country,
            subscriber_id: applicationRegistreation?.subscriber_id,
            unique_key_id: applicationRegistreation?.unique_key_id,
            callback_url: applicationRegistreation?.callback_url,
            key_pair: {
              signing_public_key: applicationRegistreation?.signing_public_key,
              encryption_public_key: applicationRegistreation?.encryption_public_key,
              valid_from: applicationRegistreation?.valid_from,
              valid_until: applicationRegistreation?.valid_until
            }
          },
          network_participant: networkData,
          timestamp: moment().format('YYYY-MM-DD h:mm:ss a'),
          request_id: applicationRegistreation?.request_id
        }
      },
      // InterfaceMenuMapping: menuMapping ,
      LimitedToTenantMappings: {
        LimitedToTenantIds: applicationRegistreation?.LimitedToTenantIds
      },
      ChannelMappings: {
        ChannelNames: applicationRegistreation?.ChannelNames
      },
      AccountTypeMappings: {
        AccountTypes: accountTypes 
      },
      NetworkMappings: {
        Networks: applicationRegistreation?.Networks
      }
    }
    if (parmas?.id > 0) {
      await dispatch(applications.resetAction({ actionType: 'update' }))
     await dispatch(applications.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/applications`,entity:'applications',jsonData:{
          
    Records: [
      { ...Data }
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(applications.resetAction({ actionType: 'create' }))
      await dispatch(applications.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/applications`,entity:'applications',jsonData:{
          
      Records: [
        { ...Data }
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/platform-management/applications')
} 

useEffect(
  () => {
    if (currentChange.field === 'DomainId') {
      setCombinationFunctionInfo()
    }
  },
  [functionItems]
)

useEffect(
  () => {
    if (currentChange.field === 'MenuIds' && !hasAddedMenuRow ) {
      setCombinationMenuMappingInfo()
      setHasAddedMenuRow(true);
    }
  },
  [menuMapping]
)
useEffect(
  () => {
    if (currentChange.field === 'FileTypeId') {
      setMediaCombinationInfo()
    }
  },
  [mediaFiles]
)

const changeImage = (idx: number, templateField: any, fileType: any) => {
  setMediaImageIndex(idx)
  dispatch(settings.set({ getUploadFiles: 'open' }))
  setOpenFile({
    currentFileSrc: mediaFiles[idx][templateField],
    // folder: 'applicationRegistrations',
    type: fileType
  })
}
const handleSubmit = (data: any) => {

  mediaFiles[mediaImageIndex].FileMappingURL = data
  const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
  setMediaFiles(localSelectedMedia)
}
const handleClose = () => {
  dispatch(settings.set({ getUploadFiles: 'close' }))
  
}

const setCombinationNetworkInfo = async () => {
  let localSelectednetworks = deepCopy(networkParticipants)
  localSelectednetworks.splice(
    currentChange.idx,
    1,
    { ...localSelectednetworks[currentChange.idx] }
  );
  localSelectednetworks = addNewRow({ selectedNetworksArg: localSelectednetworks });
  currentChange.field = 'subscriber_urlDONE'
  setNetworkParticipants(localSelectednetworks)
}
const setCombinationSellerInfo = () => {
  let localSelectedSeller = deepCopy(sellerOnRecords)
  localSelectedSeller.splice(
    currentChange.idx,
    1,
    { ...localSelectedSeller[currentChange.idx] }
  );
  localSelectedSeller = addNewSellerRow({ selectedSellersArg: localSelectedSeller, networkParticipant: networkParticipants, idx1: currentChange.idx1 });
  currentChange.field = 'seller_unique_key_id'
  setSellerOnRecords(localSelectedSeller)
}
useEffect(
  () => {
    if (currentChange.field === 'subscriber_url') {
      setCombinationNetworkInfo()
    }
  },
  [networkParticipants]
)

useEffect(
  () => {
    if (currentChange.field === 'seller_unique_key_id') {
      setCombinationSellerInfo()
    }
  },
  [networkParticipants]
)

    return (
    <>

{getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         />}
       {isLoading ? <PageLoader /> : 
         <ApplicationRegistrationComponent
         applicationRegistreation={applicationRegistreation}
         changeImage={changeImage}
         channels={channelItems?.result?.items}
         deleteItems={deleteItems}
         deleteSelectedNetwork={deleteSelectedNetwork}
         deleteselectedSellerOnRecord={deleteselectedSellerOnRecord}
         domainFunctions={DomainFunctionItems?.result?.items}
         domains={DomainItems?.result?.items}
         domainDetails={domainItems?.result?.items}
         networks={NetworkItems?.result?.items}
         functionItems={functionItems}
         handleFormFunctionItemChange={handleFormFunctionItemChange}
         mediaFiles={mediaFiles}
         handleFormMenuMappingItemChange={handleFormMenuMappingItemChange}
         menuMapping={menuMapping}
         networkParticipants={networkParticipants}
         onFormCancel={back}
         onFormChange={handleFormChange}
         onFormItemChange={handleFormMediaChange}
         onFormNetworkChange={handleFormItemNetworkChange}
         onFormSellerItemChange={handleFormSellerItemChange}
         onFormSubmit={handleFormSubmit}
         selectedApplicationRegistreation={selectedApplicationRegistreation}
         sellerOnRecords={sellerOnRecords}
         tenants={tenantItems?.result?.items}
         deleteMenuMappingItems={deleteMenuMappingItems}
     />
    } 
          </>
    )
    
    }
   
    export default Application;
